var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarthSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3179,
    cy: 16.0916,
    r: 14.597,
    stroke: "#F5F5F5",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2234 6.85339C25.811 7.24411 25.2645 7.64133 24.5553 8.02679C22.5488 9.11724 19.6402 9.85339 16.3179 9.85339C12.9956 9.85339 10.087 9.11724 8.08054 8.02679C7.37129 7.64133 6.82479 7.24411 6.41242 6.85339H3.88208C5.50745 9.74786 10.4602 11.8534 16.3179 11.8534C22.1756 11.8534 27.1284 9.74786 28.7537 6.85339H26.2234Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41242 25.1034C6.82479 24.7127 7.37129 24.3155 8.08054 23.93C10.087 22.8396 12.9956 22.1034 16.3179 22.1034C19.6402 22.1034 22.5488 22.8396 24.5553 23.93C25.2645 24.3155 25.811 24.7127 26.2234 25.1034L28.7537 25.1034C27.1284 22.2089 22.1756 20.1034 16.3179 20.1034C10.4602 20.1034 5.50745 22.2089 3.88208 25.1034L6.41242 25.1034Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3182 2.35339C16.774 2.35352 17.313 2.58445 17.912 3.22742C18.5124 3.87195 19.0996 4.85861 19.6132 6.16199C20.6381 8.76327 21.2938 12.426 21.2938 16.5214C21.2938 20.6165 20.6381 24.2786 19.6132 26.8798C19.0995 28.1832 18.5124 29.1707 17.912 29.8153C17.3132 30.458 16.7739 30.6882 16.3182 30.6884C15.8625 30.6884 15.3225 30.4583 14.7235 29.8153C14.1231 29.1707 13.536 28.1833 13.0223 26.8798C11.9974 24.2786 11.3417 20.6165 11.3417 16.5214C11.3417 12.426 11.9974 8.76327 13.0223 6.16199C13.5359 4.85866 14.1231 3.87197 14.7235 3.22742C15.3226 2.58428 15.8624 2.35339 16.3182 2.35339Z",
    stroke: "#F5F5F5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthSvgrepoCom);
export default __webpack_public_path__ + "static/media/earth-svgrepo-com.c4822fe77cfd211f3922d73d5f5aa339.svg";
export { ForwardRef as ReactComponent };